module.exports = __webpack_public_path__ + "static/media/discover-background.aeb882d0.jpg";